import { devtools } from 'zustand/middleware';
import { create } from 'zustand';
import { createUserSlice, UserStore } from '@/stores/userStore.ts';
import { createWalletSlice, WalletStore } from './walletStore';
import { createGlobalSlice, GlobalStore } from './globalStore.ts';
import { createTournamentArenaSlice, TournamentArenaStore } from './tournamentStore';

type TralentStoreProps = UserStore & WalletStore & TournamentArenaStore & GlobalStore;

const useTralentStore = create<TralentStoreProps>()(
	devtools((...a) => ({
		...createGlobalSlice(...a),
		...createUserSlice(...a),
		...createWalletSlice(...a),
		...createTournamentArenaSlice(...a),
	})),
);

export default useTralentStore;
